import { useMemo } from 'react'

import { NewInboxTasksQuery } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import { TASK_CATEGORY_TRANSLATIONS, taskCategoryEnumValues } from './constants'

type Params = {
  taskCategoryPresets?: NonNullable<NewInboxTasksQuery['tasks']['categoryCounts']>
}

export const usePresets = ({ taskCategoryPresets }: Params) => {
  const categoryCounts = taskCategoryPresets

  const presets = useMemo(
    () =>
      taskCategoryEnumValues
        .map((value) => {
          const category = categoryCounts?.find((count) => count.category === value)

          if (!category) return

          return {
            label: TASK_CATEGORY_TRANSLATIONS[category.category]?.(),
            filter: { category: [value] },
            itemsCount: () => category?.count ?? 0,
          }
        })
        .filter((preset) => preset && preset.itemsCount() > 0)
        .filter(Boolean),
    [categoryCounts]
  )

  const categoryFilter = useMemo(
    () => ({
      label: i18n.t('tasks.filter.category'),
      type: 'in' as const,
      options: {
        options: taskCategoryEnumValues
          .map((value) => {
            const category = categoryCounts?.find((count) => count.category === value)

            if (!category) return

            return {
              label: TASK_CATEGORY_TRANSLATIONS[category.category]?.(),
              value,
              itemsCount: () => (category ? category?.count ?? 0 : 0),
            }
          })
          .filter((option) => option && option.itemsCount() > 0)
          .filter(Boolean),
      },
    }),
    [categoryCounts]
  )

  return {
    presets,
    categoryFilter,
  }
}
